import './Footer.css';

function Footer() {
    return (
        <section className="footer">
            <div className="container">
                <div className="copyright-wrap">
                    <div className="body-02 copyright-title">
                        ©Copyright 2024, All Rights Reserved by Parallel
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Footer;